import {Routes} from '@angular/router';
import {AuthGuard} from './auth.guard';
import {LandingComponent} from "./public/landing/landing.component";
import {ImprintComponent} from "./public/imprint/imprint.component";
import {PageComponent} from "./page/page.component";
import {ArchiveComponent} from "./page/archive/archive.component";
import {TrashComponent} from "./page/trash/trash.component";
import {CustomerListComponent} from "./page/customer/customer-list/customer-list.component";
import {CustomerDetailComponent} from "./page/customer/customer-detail/customer-detail.component";
import {DepartmentListComponent} from "./page/department/department-list/department-list.component";
import {DepartmentDetailComponent} from "./page/department/department-detail/department-detail.component";
import {TasktypeListComponent} from "./page/tasktype/tasktype-list/tasktype-list.component";
import {TasktypeDetailComponent} from "./page/tasktype/tasktype-detail/tasktype-detail.component";
import {ReminderComponent} from "./page/reminder/reminder.component";
import {TaskListComponent} from "./page/task/task-list/task-list.component";
import {TaskDetailComponent} from "./page/task/task-detail/task-detail.component";
import {UserListComponent} from "./page/user/user-list/user-list.component";
import {UserDetailComponent} from "./page/user/user-detail/user-detail.component";
import {DashboardComponent} from "./page/dashboard/dashboard.component";
import {SettingsComponent} from "./page/settings/settings.component";
import {ContactListComponent} from "./page/contact/contact-list/contact-list.component";
import {ContactDetailComponent} from "./page/contact/contact-detail/contact-detail.component";
import {LoginComponent} from "./public/login/login.component";
import {ErrorsComponent} from "./errors/errors.component";
import {PageNotFoundComponent} from "./errors/page-not-found/page-not-found.component";
import {TermsComponent} from "./public/terms/terms.component";
import {PriceComponent} from "./public/price/price.component";
import {FeaturesComponent} from "./public/features/features.component";

export const routes: Routes = [
    {
        path: 'landing',
        component: LandingComponent,
    },
    {
        path: 'imprint',
        component: ImprintComponent,
    },
    {
        path: 'terms',
        component: TermsComponent,
    },
    {
        path: 'price',
        component: PriceComponent,
    },
    {
        path: 'features',
        component: FeaturesComponent,
    },
    {
        path: '',
        component: PageComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        data: {title: 'Home'},
        children: [
            {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
            {path: 'archive', component: ArchiveComponent},
            {path: 'trash', component: TrashComponent},
            {path: 'customer', component: CustomerListComponent},
            {path: 'customer/:id', component: CustomerDetailComponent},
            {path: 'department', component: DepartmentListComponent},
            {path: 'department/:id', component: DepartmentDetailComponent},
            {path: 'tasktype', component: TasktypeListComponent},
            {path: 'tasktype/:id', component: TasktypeDetailComponent},
            {path: 'reminder', component: ReminderComponent},
            {path: 'task', component: TaskListComponent},
            {path: 'task/:id', component: TaskDetailComponent},
            {path: 'user', component: UserListComponent},
            {path: 'user/:id', component: UserDetailComponent},
            {path: 'dashboard', component: DashboardComponent},
            {path: 'settings', component: SettingsComponent},
            {path: 'contact', component: ContactListComponent},
            {path: 'contact/:id', component: ContactDetailComponent},
        ]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'error',
        component: ErrorsComponent,
        children: [
            {path: '**', component: PageNotFoundComponent},
        ]
    },
    {
        path: '**',
        component: ErrorsComponent,
    }
];
